import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { translate } from '@/ui/i18n';

import { ProjectExportReportProjectGateway } from '../../gateways/export-report-project.gateway';
import { ExportReportProjectActionParams } from '../export-report-project.action';

export async function exportScoreCards(
  projectExportReportGateway: ProjectExportReportProjectGateway,
  snackbarGateway: SnackbarGateway,
  params: ExportReportProjectActionParams,
): Promise<void> {
  try {
    await projectExportReportGateway.exportScoreCards(params);
    showSnackbarScoreCardSuccess(snackbarGateway);
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : undefined;
    showSnackbarError(snackbarGateway, message);
    throw error;
  }
}

function showSnackbarScoreCardSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('ReportExporter.Message.success'), {
    autoHideDuration: 4_000,
  });
}

function showSnackbarError(snackbarGateway: SnackbarGateway, message?: string) {
  snackbarGateway.error(
    translate('ReportExporter.Message.error', { message }),
    { autoHideDuration: 6_000 },
  );
}
